let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jVQ9C")).then(() => parcelRequire('2omh8'));